// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608242338/js/" + chunkId + "." + {"44":"e703fd49","225":"923744b3","481":"0f0d5ef2","486":"13da3533","770":"bda3b26d"}[chunkId] + ".0.6912152538840437.chunk.js";
};